import { compose, propEq, find } from 'ramda'

export const getUpgradePopupCTAOK = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_CTA_OK'))
)
